import Swiper from "swiper/bundle";

window.addEventListener("DOMContentLoaded", () => {
    const testimonialSliders = document.querySelectorAll(".testimonial-slider");
    testimonialSliders.forEach((s) => {
        const slidesCount = s.querySelectorAll(".swiper-slide").length;

        if (slidesCount > 1) {
            const duration = s.dataset.duration * 1000;
            const autoplay = duration > 0 ? { delay: duration, disableOnInteraction: true } : false;

            new Swiper(s, {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                autoplay: autoplay,
                navigation: {
                    enabled: true,
                    nextEl: "button.next",
                    prevEl: "button.prev",
                },
                on: {
                    init: function (swiper) {
                        const currentSlide = swiper.slides[swiper.activeIndex];
                        const colorClass = currentSlide.dataset.colorClass;
                        if (colorClass) {
                            swiper.el.dataset.currentColor = colorClass;
                            swiper.el.classList.add(colorClass);
                        }
                    },
                    slideChangeTransitionStart: function (swiper) {
                        const currentSlide = swiper.slides[swiper.activeIndex];
                        const colorClass = currentSlide.dataset.colorClass;
                        const currentColor = swiper.el.dataset.currentColor;

                        if (colorClass) {
                            if (currentColor) {
                                swiper.el.classList.remove(currentColor);
                            }

                            swiper.el.dataset.currentColor = colorClass;
                            swiper.el.classList.add(colorClass);
                        } else {
                            swiper.el.classList.remove(currentColor);
                            swiper.el.dataset.currentColor = "";
                        }
                    },
                },
            });
        } else {
           
            const currentSlide = s.querySelector(".swiper-slide");
            const colorClass = currentSlide.dataset.colorClass;

			s.classList.add(colorClass);
			s.dataset.currentColor = colorClass;

			const swiperInstance = new Swiper(s, {
                navigation: {
                    enabled: false,
                },
            });

			const prevButton = s.querySelector("button.prev");
            const nextButton = s.querySelector("button.next");

            if (prevButton) {
                prevButton.style.display = "none";
            }

            if (nextButton) {
                nextButton.style.display = "none";
            }

        }
    });
});
